/**
 * Entry point for the Meet Ava & Artie page.
 *
 * Built from Bill's third draft as its own page (his call, 2026-09-10). It is
 * the home page's sibling: same header, light and components from site.css and
 * home.css, with meet.css laying out what is new.
 */

import './styles/site.css';
import './styles/home.css';
import './styles/meet.css';
import { initReveals } from './core/reveal.js';
import { initMeetEffects } from './meet-effects.js';

initMeetEffects();
initReveals();
